import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createContactsSchemas } from 'shared/db/validation/schema/contacts';
import { Validator } from 'shared/db/validation/validator';
import {
    ContactRawRecord,
    ContactUpdateRawRecord,
} from 'shared/types/Contacts';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { ContactsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createContactsSchemas();

const addValidator = createDBEntityValidator<ContactRawRecord>(schemas.add);
const updateValidator = createDBEntityValidator<ContactUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-contacts'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createContactsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const contactsInputValidation: ContactsDBValidation = {
    add: createContactsInputValidation(addValidator, validationStrategy),
    update: createContactsInputValidation(updateValidator, validationStrategy),
    delete: createContactsInputValidation(deleteValidator, validationStrategy),
};
